import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import MissionSection from '../../components/MissionSection/MissionSection';
import EnergyProjectsMap from '../../components/EnergyProjectsMap/EnergyProjectsMap';
import KeyStatistics from '../../components/KeyStatistics/KeyStatistics';
import EnergyFinancingTrends from '../../components/EnergyFinancingTrends/EnergyFinancingTrends';
import ProjectImpactOverview from '../../components/ProjectImpactOverview/ProjectImpactOverview';
import StoriesFromField from '../../components/StoriesFromField/StoriesFromField';
import SustainableImpactSnapshots from '../../components/SustainableImpactSnapshots/SustainableImpactSnapshots';
import AboutEnergyTracker from '../../components/AboutEnergyTracker/AboutEnergyTracker';
import PartnersCollaborations from '../../components/PartnersCollaborations/PartnersCollaborations';
import './HomePageV2.scss';

const HomePageV2 = () => {
  return (
    <div className="home-page-v2">
      <HeroSection />
      <MissionSection />
      <EnergyProjectsMap />
      <KeyStatistics />
      <EnergyFinancingTrends />
      <ProjectImpactOverview />
      <StoriesFromField />
      <SustainableImpactSnapshots />
      <AboutEnergyTracker />
      <PartnersCollaborations />
    </div>
  );
};

export default HomePageV2;

